import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=2bf75f2f&"
import script from "./PdfViewer.vue?vue&type=script&lang=js&"
export * from "./PdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports